/**
 * This module is to do add some actions after DOM ready event is triggered,
 * such as to add css classes to the DOM or manipulations of DOM elements.
 *
 * @module app/components/DOMPostRenderManager
 */
import DeviceDetector from './DeviceDetector';
import jQuery from 'jquery';

/**
 * Topics for MessageBus
 *
 * @type {Object}
 *
 * @private
 */
var messageBusTopics = {

    domReady: 'AppJs.domReady',
};

/**
 * Contains the list of DOM elements to be used and their selectors and
 * modifing clases.
 *
 * @type {Object}
 *
 * @private
 */
var DOMElements = {

    body: {

        querySelector: 'body',
    },
};

/**
 * Contains the list of css classes we are going to need for the
 * initial set-up.
 *
 * @type {Object}
 *
 * @private
 */
var cssClasses = {

    oddinIOS: 'odin-ios',
};

/**
 * This will make this module start listening events declared for the DOM set-up
 *
 * @returns {void}
 *
 * @private
 */
var subscribeToMessageBus = function subscribeToMessageBus() {

    window.WH.messageBus.subscribe(messageBusTopics.domReady, onDOMReady);
};

/**
 * Add OdinIOS class in order to apply the absolute positioning
 * of the body, to fix address and toolbar on iPhone
 *
 * @returns {void}
 *
 * @private
 */
var addOdinIOSToBody = function addOdinIOSToBody() {

    jQuery(DOMElements.body.querySelector).addClass(cssClasses.oddinIOS);
};

/**
 * Event handler for DOM Ready
 *
 * @returns {void}
 *
 * @private
 */
var onDOMReady = function onDOMReady() {

    if (DeviceDetector.isIOS()) {

        addOdinIOSToBody();
    }
};

/**
 * This function initializes the communication with the native app
 *
 * @returns {void}
 *
 * @public
 */
var init = function init() {

    subscribeToMessageBus();
};

export default { init };

